import { useMemo, Fragment } from 'react';
import { avoidBreakInside } from '@provider/print';
import { textCorrectionInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useTaskContext } from '../../context.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { stateBox } from './input.facit.style.js';
import { input } from './input.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FacitInput(props) {
  const context = useTaskContext();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => textCorrectionInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const statusForOriginalWords = useMemo(() => textCorrectionInput.entry.getStatusForOriginalWords(props.input, inputEntry), [inputEntry, props.input]);
  const words = useMemo(() => textCorrectionInput.entry.getStatusForAllWords(props.input, props.entry), [props.entry, props.input]);
  const fragments = useMemo(() => {
    let currentOriginalWordIndex = 0;
    return words.map((word, index) => {
      if (word.state === "linebreak") {
        return "\n";
      }
      if (!word.essential) {
        return /*#__PURE__*/jsxs(Fragment, {
          children: [word.text, " "]
        }, index);
      }
      const state = (() => {
        if (props.entryType === "user-entry") {
          return word.correct ? "correct" : "incorrect";
        }
        const didUserAnswerCorrectly = statusForOriginalWords[currentOriginalWordIndex++]?.correct;
        return didUserAnswerCorrectly ? "correct" : "should-have";
      })();
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(StateBox, {
          className: stateBox,
          state: state,
          textTheme: "colored",
          children: word.text
        }), " "]
      }, index);
    });
  }, [props.entryType, statusForOriginalWords, words]);
  return /*#__PURE__*/jsx("div", {
    className: input,
    "data-readonly": true,
    "data-context": context,
    ...avoidBreakInside(),
    children: fragments
  });
}

export { FacitInput };
//# sourceMappingURL=input.facit.js.map
